import { EMarkAsReadNotificationActionTypes, TMarkAsReadNotificationFailed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const markAsReadFailed: () => TMarkAsReadNotificationFailed =
  actionGenerator<EMarkAsReadNotificationActionTypes.Failed>(EMarkAsReadNotificationActionTypes.Failed);
